var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42376 8.62227H24.9268C28.568 8.62227 31.5255 11.5791 31.5255 15.2224C31.5255 18.8657 28.568 21.8226 24.9268 21.8226H5.12651C4.4641 21.8226 3.92482 22.3602 3.92482 23.0226C3.92482 23.685 4.4641 24.2227 5.12651 24.2227H24.9268C29.8928 24.2227 33.9268 20.1894 33.9268 15.2224C33.9268 10.2555 29.8928 6.22221 24.9268 6.22221H4.42376L8.3749 2.27051C8.84199 1.8025 8.84199 1.04168 8.3749 0.573665C7.90569 0.105653 7.14561 0.105653 6.6764 0.573665L0.676437 6.57381C0.451385 6.79942 0.326118 7.10303 0.326118 7.42224C0.326118 7.74145 0.451385 8.04505 0.676437 8.27066L6.6764 14.2708C7.14561 14.7388 7.90569 14.7388 8.3749 14.2708C8.84199 13.8028 8.84199 13.042 8.3749 12.574L4.42376 8.62227Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.fb9bf790f4009c2bcc5208fe7e4a255e.svg";
export { ForwardRef as ReactComponent };